<template lang="html">
   <div class="test-form">

      <Table 
         :icon="Transaction.tables.transactions.icon" 
         :table_fields="Transaction.tables.transactions.table_fields" 
         :table_data="transactions" 
         :title="Transaction.tables.transactions.title" 
         :search_fields="Transaction.tables.transactions.search_fields"
         :row_data="Transaction.tables.transactions.row_data"
         @on-action="handleActions"
      />
   </div>
</template>

<script>
import transaction from "./rsc/stores/transactions/transaction.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('transaction')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('transaction',transaction,this.$store)

      setTimeout(() => {
         EventBus.$emit('actions:register',{
            title: '',
            actions: []
         })
      },200);
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'Transaction',
         'transactions',
         'show',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
         'fetchTransactionsDashboard',
      ]),
      handleActions(){

      }
   },
   async mounted(){
      utils.registerModule('transaction',transaction,this.$store)
      await this.fetchTransactionsDashboard()
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>